export const contactsData = {
    email: 'muhammadmuzammal56@gmail.com',
    phone: '+92 3107278988',
    address: '620/8 H block sabzazar, Lahore',

    sheetAPI: ''
}